<!--注销用户-->
<template>
  <div v-loading="loading" class="payment-account-user">
    <div class="module">
      <h5 class="module-title">注销用户</h5>
      <div class="module-tips">
        提示：用户注销后将无法再登录支付平台，请谨慎操作
      </div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="请选择您要注销的用户："
              prop="userId"
              :rules="rules.userId"
              label-width="170px"
            >
              <el-radio-group v-model="ruleForm.userId">
                <el-radio
                  v-for="item in userList"
                  :key="item.userId"
                  :label="item.userId"
                  >{{ item.realName }}</el-radio
                >
              </el-radio-group>
              <!--              <el-checkbox-group-->
              <!--                v-model="ruleForm.userId"-->
              <!--                :max="userList.length ? userList.length - 1 : 1"-->
              <!--              >-->
              <!--                <el-checkbox-->
              <!--                  v-for="item in userList"-->
              <!--                  :key="item.userId"-->
              <!--                  :label="item.userId"-->
              <!--                  >{{ item.realName }}</el-checkbox-->
              <!--                >-->
              <!--              </el-checkbox-group>-->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <div style="margin-top: 20px" class="footer-button">
      <eui-btn type="secondary" @click="handleReturn">返 回</eui-btn>
      <div>
        <eui-btn type="weak" @click="handleReturn">取 消</eui-btn>
        <eui-btn type="primary" @click="handleSubmit">提 交</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import bus from '@/components/common/bus';
import _ from 'lodash';
import ApplicantInfo from './applicantInfo';

export default {
  name: 'AddUser',
  components: { ApplicantInfo },
  mixins: [],
  data() {
    return {
      loading: false,
      defaultForm: {},
      ruleForm: {
        userId: '',
      },
      rules: {
        userId: [
          {
            required: true,
            validator: async (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择注销用户'));
              } else {
                // 当前企业必须至少有一个经办人员和一个审核人员
                const res = await Api.cancelEpayAccountUserCheck({
                  userId: value,
                });
                if (res.code === '200' && !res.data.status) {
                  callback(res.data.msg);
                }
                callback();
              }
            },
            trigger: 'change',
          },
        ],
      },
      userList: [],
    };
  },
  watch: {},
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const res = await Api.getAccountValidUserList();
      if (res.code === '200') {
        this.userList = res.data;
      }
    },
    // 提交
    async handleSubmit() {
      const formName = ['applicantInfo'];
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (!this.$refs[item]?.$refs.ruleForm) {
            reject();
          }
          this.$refs[item].$refs.ruleForm.validate((valid) => {
            if (valid) {
              resolve();
            }
          });
        });
      };
      const userForm = new Promise((resolve) => {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            resolve();
          }
        });
      });
      Promise.all([userForm, ...formName.map((item) => validates(item))]).then(
        () => {
          this.handleSave();
        }
      );
    },
    // 保存
    async handleSave() {
      const params = {
        ..._.cloneDeep(this.$refs.applicantInfo.ruleForm),
        ...this.ruleForm,
      };
      params.accountUserApplicantAttachAOList.forEach((item) => {
        // 申请人证件
        if (item.attachType === 'AC') {
          item.certificateValidityBegin = item.certificateTimeRange?.[0];
          item.certificateValidityEnd = item.certificateTimeRange?.[1];
          delete item.certificateTimeRange;
        }
        item.isLongTernEffective = item.isLongTernEffective ? 1 : 0;
      });
      console.log(params, 'params');
      Api.cancelEpayAccountUser(params).then((res) => {
        if (res.code === '200') {
          this.$message.success('注销用户成功');
          this.handleReturn();
        }
      });
    },
    handleReturn() {
      bus.$emit('close_current_tags');
      this.$router.replace('/paymentAccount');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/common.scss';
</style>
